import { render, staticRenderFns } from "./WelcomeToScan.vue?vue&type=template&id=4d83ec9a&scoped=true&"
import script from "./WelcomeToScan.vue?vue&type=script&lang=js&"
export * from "./WelcomeToScan.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeToScan.vue?vue&type=style&index=0&id=4d83ec9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d83ec9a",
  null
  
)

export default component.exports